import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
} from '@material-ui/core';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
    select: {
        minWidth: '100%',
    },
    menuPaper: {
        maxHeight: '150px'
    }
});



class FormFieldCodiceUtente extends Component {

    render() {
        const { classes, value, helperText, codici_utente, onCodiceUtenteChange } = this.props;

        return (
            <FormControl
                variant="outlined"
                size="small"
                fullWidth
                error={helperText !== '' ? true : false}
            >
                <Select className={classes.select}
                    value={value}
                    onChange={e => onCodiceUtenteChange(e)}
                    autoWidth={false}
                    MenuProps={{ classes: { paper: classes.menuPaper } }}
                >
                    {codici_utente.map((item, index) => <MenuItem value={item} key={index}>{item}</MenuItem> )}
                </Select>

                {helperText !== '' ? <FormHelperText>{helperText}</FormHelperText> : null}
            </FormControl>
        );
    }
}

FormFieldCodiceUtente.propTypes = {
    onCodiceUtenteChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    helperText: PropTypes.string.isRequired,

    codici_utente: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default withStyles(styles)(FormFieldCodiceUtente);